<script setup lang="ts">
import { onMounted } from 'vue'
import { usePreferenceStore } from './stores/preference'
import { useDocumentStore } from './stores/document'

const preference = usePreferenceStore()
const documentStore = useDocumentStore()

onMounted(async () => {
  await preference.hydrate()
  await documentStore.seedBuiltins()
})
</script>

<template>
  <div class="mesh-bg min-h-full">
    <RouterView />
  </div>
</template>
